import { calculatePercentage, formatPercentage } from "../../utils/number";

import styles from "./SplitProgressBar.module.scss";

type SplitProgressValue = {
  value: number;
  color: string;
};

type SplitProgressBarProps = {
  showLabel?: boolean;
  leftSegment: SplitProgressValue;
  rightSegment: SplitProgressValue;
};

export const SplitProgressBar: React.FC<SplitProgressBarProps> = ({ leftSegment, rightSegment, showLabel = true }) => {
  const total = leftSegment.value + rightSegment.value;
  const leftPercentage = calculatePercentage(leftSegment.value, total);
  const rightPercentage = calculatePercentage(rightSegment.value, total);

  return (
    <div className={styles.container}>
      {showLabel && <p className={styles.label}>{formatPercentage(leftPercentage, 0)}</p>}
      <div className={styles.progressBar}>
        <div
          className={styles.progressSegment}
          style={{ width: `${leftPercentage}%`, backgroundColor: leftSegment.color }}
        />
        <div
          className={styles.progressSegment}
          style={{ width: `${rightPercentage}%`, backgroundColor: rightSegment.color }}
        />
      </div>
      {showLabel && <p className={styles.label}>{formatPercentage(rightPercentage, 0)}</p>}
    </div>
  );
};
